import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { axios } from 'services/axios';
import {
    handleBillingNotesCRUD,
    getBillingNotes,
} from '../utils/billingNotesHandler';

const useUpdatePartner = (
    formData,
    resetToMainTable,
    deletedBillingNoteIDs,
    initialFormData,
) => {
    const queryClient = useQueryClient();
    const { restError } = useSelector((state) => state.modal);

    return useMutation({
        mutationFn: async () => {
            // Clean up formData before sending
            const cleanedData = { ...formData };
            
            // Remove defaultPartnerPlan if it's a string (just the name)
            // The API only needs defaultPartnerPlanID
            if (typeof cleanedData.defaultPartnerPlan === 'string') {
                delete cleanedData.defaultPartnerPlan;
            }
            
            
            
            const response = await axios.put('/partner', cleanedData);
            
            // Update the partner first, then handle billing notes CRUD operations
            const initialBillingNotes = getBillingNotes(initialFormData);
            const billingNotes = getBillingNotes(formData);

            if (billingNotes?.length || deletedBillingNoteIDs?.length) {
                await handleBillingNotesCRUD(
                    billingNotes,
                    initialBillingNotes,
                    deletedBillingNoteIDs,
                );
            }
            
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['partners']);
            queryClient.invalidateQueries(['partner', formData.id]);
            if (resetToMainTable) {
                resetToMainTable();
            }
            toast.success('Updated partner successfully');
        },
        onError: (error) => {
            if (error?.response?.data?.errors) {
                const errors = error.response.data.errors;
                const errorMessages = Object.values(errors)?.flat().join('\n');
                toast.error(errorMessages);
            } else if (restError) {
                toast.error(restError);
            } else {
                const errorMessage =
                    error?.response?.data?.title ||
                    error?.message ||
                    'Failed to update partner';
                toast.error(errorMessage);
            }
        },
        staleTime: 0,
    });
};

export default useUpdatePartner;
